import { createReducer } from "@reduxjs/toolkit";
import { getAssociatedProceduresSuccess, getLocationBasicInfoSuccess, getLocationCommentSuccess, getLocationDatesSuccess, getLocationDocumentListSuccess, getLocationDropDownSuccess, getLocationOverdueListSuccess, getLocationSupplierSuccess, getMaintenanceScheduleSuccess, loadingData, saveLocationBasicInfoSuccess, saveLocationCommentSuccess, saveLocationDatesSuccess, saveLocationSupplierSuccess } from "./locationAction";
import { LocationOverdueItem } from "src/pages/Locations/List/table-location-overdue.config";
import { MaintenanceScheduleItem } from "src/pages/Locations/MaintenanceCalendar";

export interface LocationDocumentList {
  id: number;
  organizationId: number;
  shortDescription: string;
  activeDoc: string;
}
export interface ILocationState {
  locationDropdown?: any[];
  isLoading?: boolean;
  locationBasicInfo?: any;
  locationDates?: any;
  locationSupplier?: any;
  comments?: any[];
  associatedProcedures?: any[];
  locationDocuments?: LocationDocumentList[];
  dataCount?: number;
  overdueList?: LocationOverdueItem[];
  overdueDataCount?: number;
  scheduleItems?: MaintenanceScheduleItem[];
}

const initialState: ILocationState = {
  locationDocuments: [],
  overdueList: [],
  scheduleItems: [],
};

export const locationReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(loadingData, (state, action) => {
      state = {
        ...state,
        isLoading: action.payload,
      };
      return state;
    })
    .addCase(getLocationDropDownSuccess, (state, action) => {
      state = {
        ...state,
        locationDropdown: action.payload,
      };
      return state;
    })
    .addCase(getLocationBasicInfoSuccess, (state, action) => {
      state = {
        ...state,
        locationBasicInfo: action.payload,
      };
      return state;
    })
    .addCase(saveLocationBasicInfoSuccess, (state, action) => {
      state = {
        ...state,
        locationBasicInfo: action.payload,
      };
      return state;
    })
    .addCase(getLocationDatesSuccess, (state, action) => {
      state = {
        ...state,
        locationDates: action.payload,
      };
      return state;
    })
    .addCase(saveLocationDatesSuccess, (state, action) => {
      state = {
        ...state,
        locationDates: action.payload,
      };
      return state;
    })
    .addCase(getLocationSupplierSuccess, (state, action) => {
      state = {
        ...state,
        locationSupplier: action.payload,
      };
      return state;
    })
    .addCase(saveLocationSupplierSuccess, (state, action) => {
      state = {
        ...state,
        locationSupplier: action.payload,
      };
      return state;
    })
    .addCase(getLocationCommentSuccess, (state, action) => {
      state = {
        ...state,
        comments: action.payload,
      };
      return state;
    })
    .addCase(saveLocationCommentSuccess, (state, action) => {
      state = {
        ...state,
        comments: action.payload,
      };
      return state;
    })
    .addCase(getAssociatedProceduresSuccess, (state, action) => {
      state = {
        ...state,
        associatedProcedures: action.payload,
      };
      return state;
    })
    .addCase(getLocationDocumentListSuccess, (state, action) => {
      state = {
        ...state,
        locationDocuments: action.payload?.data,
        dataCount: action.payload?.dataCount,
      };
      return state;
    })
    .addCase(getLocationOverdueListSuccess, (state, action) => {
      state = {
        ...state,
        overdueList: action.payload?.data,
        overdueDataCount: action.payload?.dataCount,
      };
      return state;
    })
    .addCase(getMaintenanceScheduleSuccess, (state, action) => {
      return { ...state, scheduleItems: action.payload };
    });
});
